export default () => `
  <div class="content">
    Attaching with Direct-To-Deck method, OSB or Plywood,requires 4 
    additional #12-14X2.5" screws. Attaching to rafters requires 5/16" lag
    bolt. Proper fastener will be included in Bom list. 5/16" lag
    bolt will not appear separately because it is included with 
    the attachment kit.
  </div>
`;
